import { createRootRoute, Outlet } from "@tanstack/react-router"

import { PortalShell } from "@/components/Layout/PortalShell"

export const Route = createRootRoute({
  component: PortalRootLayout,
})

function PortalRootLayout() {
  return (
    <PortalShell>
      <Outlet />
    </PortalShell>
  )
}
